import { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import api from "../../services/api";
import Template from "../../template";
import { toast } from "react-toastify";

import CarregarPDFAluno from '../../components/CarregarPDFAluno/';
import { rasterizarPrimeiraPagina } from "../../utils/rasterizarPdf";

import * as S from "./styled";

function Redacoes(props) {
  const { id, redacao } = props.match.params;
  const history = useHistory();

  const { isDragReject } = useDropzone({
    accept: "application/pdf",
  });

  const [arquivo, setArquivo] = useState("");


  /*
    Envia a imagem da 1ª página quando a atividade é IA + Humano, e devolve se ela
    é desse fluxo — o chamador usa isso para decidir o redirecionamento.

    Vai em requisição separada, depois do envio do PDF, de propósito: o POST /redacao
    continua exatamente como sempre foi. Se esta parte falhar, a redação já está
    enviada e continua sendo IA + Humano (por isso o retorno não muda); o aluno não
    perde nada, só fica sem a correção prévia, que o corretor pode reprocessar.
  */
  async function enviarImagemParaIA(file) {
    let ehIAHumano = false;

    try {
      const { data } = await api.get(`/correcao-ia-humano/${id}/elegivel`);

      if (!data?.ia_humano) {
        return false;
      }

      ehIAHumano = true;

      const imagem = await rasterizarPrimeiraPagina(file);

      const corpo = new FormData();
      corpo.append("imagem", imagem);

      await api.post(`/correcao-ia-humano/${id}/imagem`, corpo);
    } catch (error) {
      console.error("Não foi possível preparar a redação para a correção por IA:", error);
    }

    return ehIAHumano;
  }

  async function sendFile(file) {
    const data = new FormData();

    data.append("id", id);

    if (file) {
      data.append("image", file);
    }

    try {
      const retorno = await api.post("redacao", data);

    //  console.log(retorno);
      setArquivo(`${retorno.data.arquivo}`)
      //history.push(`/correcao/${id}`);

      if (file && (await enviarImagemParaIA(file))) {
        /*
          Em IA + Humano não há o que o aluno faça nesta tela depois de enviar: a
          correção passa pela IA e depois pelo corretor. Mandar para Minhas Redações
          evita que ele fique olhando o preview achando que falta alguma etapa.
        */
        toast.success("Redação enviada! Você será avisado quando a correção estiver pronta.");
        history.push("/minhas-redacoes");
      }
    } catch (error) {}
  }

  const onDrop = useCallback((acceptedFiles) => {
    //const fileUrl = URL.createObjectURL(file);

    if (acceptedFiles[0] === undefined) {
      toast.error("Tipo de arquivo invalido");
      return false;
    }

    const file = acceptedFiles[0];
    
    // Verificar se o arquivo é maior que 10MB (10 * 1024 * 1024 bytes)
    const maxSize = 10 * 1024 * 1024; // 10MB em bytes
    if (file.size > maxSize) {
      toast.error("O arquivo deve ter no máximo 10MB");
      return false;
    }

    toast('Carregando arquivo');

   // setArquivo(file.name);
    sendFile(file);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    async function getPDF() {
      try {
        const { data } = await api.get(`/getRedacao/${id}`);

        setArquivo(data[0].pdf);
      } catch (error) {}
    }

    if (redacao === "redacao") {
      getPDF();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf",
  });

  return (
    <Template>
      <S.MainWrapper>
        <Container>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <Row>
                  <Col>
                    <legend>
                      <strong>Enviar Redação</strong> {arquivo}
                    </legend>
                  </Col>
                </Row>

                <Row>
                  {arquivo ? (
                    <>
                      <Col>
                        <CarregarPDFAluno
                          pdf={`${arquivo}`}
                          id={id}
                          setArquivo={setArquivo}
                          dadosRedacao={[]}
                          preview={true}
                        />
                      </Col>
                    </>
                  ) : (
                    <Col>
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input
                          name="image"
                          accept="application/pdf"
                          {...getInputProps()}
                        />
                        {isDragActive ? (
                          <p>Carregar PDF...</p>
                        ) : (
                          <p>
                            Clique aqui, ou arraste sua redação no formato PDF...
                          </p>
                        )}
                        <p>
                          {isDragReject && <p>Só pode enviar PDF</p>}
                        </p>
                      </div>
                    </Col>
                  )}
                </Row>
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>
    </Template>
  );
}

export default Redacoes;
